export default "__VITE_ASSET__FQatpQ0Z__"